/**
 * An abort signal that fires after `ms`, for a request that needs a deadline.
 * It stands in for AbortSignal.timeout, which does not exist before Safari 16,
 * a browserslist target. The request rejects with an AbortError, not a
 * TimeoutError. Call clear() once the request settles.
 *
 * @param {number} ms
 * @returns {{signal: AbortSignal, clear: function(): void}}
 */
export function createTimeoutSignal(ms) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ms);

    return {
        signal: controller.signal,
        clear: () => clearTimeout(timer),
    };
}
